// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionTitle_title__IKHF0","fadeIn":"SectionTitle_fadeIn__G_0Pj","titleYellow":"SectionTitle_titleYellow__xJsT4"};